import React, { Component } from 'react';
import xtend from 'xtend';
// import { List } from 'immutable';

const Element = props => {
    const { displayName, description, el} = props
    return (
        <div className="preference">
            <div>
                <h4>{displayName}</h4>
                <p>{description}</p>
                <div>{el}</div>
            </div>
            <hr/>
        </div>
    )
}

const Tab = props => {
    const {
        activeTab,
        assets,
        channels,
        edits,
        preference,
        settings,
        peerStatus
    } = props;
    
    const mergedSettings = xtend(settings, edits.preferences)
    const contexts = edits.contexts

    // Rendered Preferences
    let renderedPreferences = [];

    if (activeTab != 'templates') {
        const p = preference[activeTab].preferences;
        Object.keys(p).forEach((key, i) => {
            // Don't show the P2P config to Clients who don't have it enabled on their Account
            if (key == 'peerToPeer' && peerStatus.enabled == false) return

            let val = mergedSettings[key];
            let context = (p[key].hasOwnProperty('context')) ?
                xtend(p[key].context, contexts[key] || {}) :
                false

            let data = (activeTab == 'playerConfig') ?
                assets : (activeTab == 'channel') ?
                    channels : false;
            const renderedOption = props.renderUtils.renderPreference(
                key,
                val,
                p[key],
                props.handleChange.bind(null, key),
                context,
                data,
                mergedSettings
            )
            renderedPreferences.push(<Element
                    key={i}
                    displayName={p[key].displayName}
                    description={p[key].description}
                    el={renderedOption}
                />)
            
        })

    } else {
        const preferenceOptions = preference[activeTab].options;
        preferenceOptions.forEach(function (template, i) {
            renderedPreferences.push(<Element
                key={i}
                displayName={template.displayName}
                description={template.description}
                el={props.renderUtils.renderTemplate(
                    edits.template,
                    template,
                    i
                )}
            />)
        })
    }
    if (preference[activeTab].preferenceOrder) {
        renderedPreferences.sort((a,b) => preference[activeTab].preferenceOrder.indexOf(a.props.el.props.preferenceName) - preference[activeTab].preferenceOrder.indexOf(b.props.el.props.preferenceName))
    }
    return (<section>{renderedPreferences}</section>);
}

Tab.propTypes = {};

export default Tab;
